export {
  mapDtoToWebCams,
  mapDtoToWebCamsPage,
  mapDtoToWebCamTypes,
} from "./mappers";
export type { WebCamsPageType, WebCamsType, WebCamTypesType } from "./types";
